export const beadingThreadWiresLevelTwo = [
    {
        "parentCategoryId": "beading_thread_n_wires",
        "level": 2,
        "name": "Beading Thread",
        "categoryId": "beading_thread"
    },
    {
        "parentCategoryId": "beading_thread_n_wires",
        "level": 2,
        "name": "Beading Wire",
        "categoryId": "beading_wire"
    },
    {
        "parentCategoryId": "beading_thread_n_wires",
        "level": 2,
        "name": "Chain",
        "categoryId": "chain"
    }

]
